import { getFileUrl } from "@/utils/url";

export class InitInfo {
	companyName:string = "";
	addressLine1:string = "";
	postalAndPlace:string = "";
	tel:string = "";
	email:string = "";
	vatNo:string = "";
	bank:string = "";
	logoToken:string | undefined;
	firstname:string = "";
	lastname:string = "";

	getLogoUrl():string {
		if (!this.logoToken) {
			return "";
		}
		return getFileUrl(this.logoToken);
	}

	getInitLayoutsJson(){
		return {
			CompanyName: this.companyName,
			AddressLine1: this.addressLine1,
			PostalAndPlace: this.postalAndPlace,
			Tel: this.tel,
			VatNo: this.vatNo,
			Bank: this.bank,
			Email: this.email,
			LogoToken: this.logoToken,
		};
	}
}